import { IBudgetProgramFilterRequest } from '../../../../model/sge/budget-program/request/budget-program-filter-request';
import { IBudgetProgramResponse } from '../../../../model/sge/budget-program/response/budget-program-response';
import { IBudgetUnitResponse } from '../../../../model/sge/budget-unit/response/budget-unit-response';

export type BudgetProgramSearchState = {
    parameters: IBudgetProgramFilterRequest;
    budgetUnits: IBudgetUnitResponse[];
    searchTrigger: number;
    drawer: { open: boolean; record?: IBudgetProgramResponse };
};

export enum ACTION_TYPES {
    updateParameter = 'updateParameter',
    setBudgetUnits = 'setBudgetUnits',
    triggerSearch = 'triggerSearch',
    openDrawer = 'openDrawer',
    closeDrawer = 'closeDrawer',
}

export const BudgetProgramSearchReducer = (state: BudgetProgramSearchState, action: any): BudgetProgramSearchState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.updateParameter:
            return { ...state, parameters: { ...state.parameters, ...payload } };
        case ACTION_TYPES.setBudgetUnits:
            return { ...state, budgetUnits: payload };
        case ACTION_TYPES.triggerSearch:
            return { ...state, searchTrigger: state.searchTrigger + 1 };
        case ACTION_TYPES.openDrawer:
            return { ...state, drawer: { open: true, record: payload } };
        case ACTION_TYPES.closeDrawer:
            return { ...state, drawer: { open: false } };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
